export const articlesData = [
    {
        id: "psy-1",
        title: "«Мне плохо»",
        shortText: "Проблема эмоциональной саморегуляции...",
        fullText: `
        В основе всех наших человеческих сложностей и переживаний лежат эмоции и чувства.
Проблема подавления эмоций тесно связана с требованиями современного общества, где
превалирует культ рационального отношения к жизни и культ так называемой
«позитивности», вследствие чего сформировалась достаточно негативная установка по
отношению к эмоциям и чувствам. Подавление эмоций формирует неадекватные формы
психологической защиты и способствуют возникновению тревоги и напряжению. Все это
приводит к потере аутентичности и своей психологической устойчивости. Поэтому без
формирования осознанного управления своим эмоциональным состоянием невозможно
интегрированное поведение.
Неспособность обращаться с эмоциями имеет достаточно тяжелые личностные и
социальные последствия, что вызывает постоянную напряженность и ведет к развитию
неврозов и психосоматических проблем.
Чтобы избежать разрушительного влияния негативных эмоций на состояние здоровья,
необходимо научиться навыкам здоровой эмоциональной саморегуляции, мышечного
расслабления и глубокого дыхания, активирующего парасимпатический отдел
вегетативной нервной системы и поиску форм выражения своих эмоций, что ведет, в
конечном счете, к открытости и расслаблению.
    `,
    },
    {
        id: "psy-2",
        title: "«Я не знаю, что делать со злостью»",
        shortText: "Проблема подавления агрессии...",
        fullText: `
        Поскольку целые поколения выросли в отсутствие психологической культуры в обществе,
где нам внушали,что «злиться нельзя», «быть агрессивным плохо», то это привело к
подавлению здоровых агрессивных импульсов и фундаментальной проблеме -
нарушенной эмоциональной регуляции. Это случаи, когда человек избегает любых
конфронтаций, не отстаивая свое пространство, не способен отказывать. Есть множество
примеров когда клиенты говорят «я женился потому что не мог сказать «нет» или отдал
свое состояние, согласился не на те условия и т.п.
Хроническое подавление злости ведет к чрезмерным выплескам гнева и это только
усугубляет проблемы, образуя замкнутый круг.
«Позитивный эмоциональный круг» начинает свое действие, когда человек
воздерживается от импульсивных реакций и учится переживать свои негативные эмоции.
Первый шаг состоит в том, чтобы ничего не предпринимать, когда в мозгу
поднимающийся уровень кортизола создает ощущение угрозы. Не предпринимать
ничего идет вразрез с глубинными инстинктами, но позволяет подумать над
альтернативными вариантами действий и внести в жизнь изменения. Этим можно
создать новый нейронный путь, новые нейронные сети и определенные жизненные
перспективы. И это особенный тренируемый навык.
В основе эмоциональной регуляции осознавание является мишенью, где особое
внимание обращается на проживание телесного опыта, когда наблюдение телесных
ощущений помогает снизить захваченность эмоциями, снижает интенсивность
переживаний, позволяя осознанно проживать свои чувства и отреагировать их в более
приемлемом выражении вместо импульсивных реакций, привычных способов
подавления неприятных чувств или усиления защитных паттернов поведения.
Присвоенная агрессия это личный источник энергии!
        `
    },
    {
        id: "psy-3",
        title: "«Врачи говорят,что все нормально, а все равно болит»",
        shortText: "психосоматические проблемы ...",
        fullText: `
        В настоящее время уже не вызывает сомнений, что большинство больных,
обращающихся с соматическими жалобами, составляют практически здоровые лица,
нуждающиеся лишь в коррекции эмоционального состояния . Сердечные заболевания
врачи лечат медицинскими препаратами, но они могут не помочь человеку, который
чувствует себя одиноким или нелюбимым и от этого испытывает страхи или печаль.
Подавленные эмоциональные переживания ведут к телесному напряжению, которое
становится хроническим и постепенно трансформируется в соматические симптомы, а
потом и в психосоматические заболевания
Первая стадия-соматизация. От чувства к психической боли. Острая боль превращается в
соматическую боль потому что переживать свои чувства мы можем только телесно, путем
напряжения группы мышц. Со временем эта боль становится менее интенсивной и
хронизируется. Механизмом фиксации симптома является хроническое напряжение низкой
интенсивности. Существование хронического напряжения в определенной части тела
нарушает обменные процессы и создает телесную готовность для образования
симптоматики.Напряжение начинает зашкаливать и далее идет нарушение
физиологических процессов.: нарушение метаболизма в этой области тела, увеличение
секреции одних гормонов и снижение других и тому подобные, известные врачам
процессы.
В терапии создаются условия для пространства отчужденного опыта, которое фиксируется
в симптоме, и «оживления» симптома.
А это предполагает рассмотрение потребностей человека,его жизненных смыслов ,
поведенческих реакций. Такой процесс позволяет позволяет человеку, осознавать свои
вытесненные потребности,высвободить хроническое напряжение и присвоить энергию
для ее реализации.
        `
    },
    {
        id: "psy-4",
        title: "«Я не знаю как обращаться со своим ребенком»",
        shortText: " проблема детско-родительских отношений ...",
        fullText: `
        Из психологии эмоционального развития известно, что процесс взросления
невозможен без содействующей и помогающей окружающей среды и что на развитие
ребенка оказывает влияние эмоциональное воздействие родителей. Первой
потребностью любого ребенка является потребность в поддержке и эмоциональном
тепле, что означает глубокий контакт с ребенком на уровне чувств, а не проявление
заботы.
Профессор Алан Шор, исследовавший огромное количество научной литературы и
совершивший значимый вклад в развитие неврологии, подчеркивает, что рост клеток
мозга — «следствие взаимодействия младенца с главным опекуном, чаще всего —
матерью». Развитие мозга младенца «нуждается в позитивном взаимодействии между
матерью и ребенком. От этого зависит формирование важнейших мозговых структур».
Особая роль в развитии ребенка и его эмоциональной сферы традиционно отводится
фактору взаимодействия матери и ребенка.
Психолог Барбара Фредриксон говорит об этом так: «Где-то в нашем мозге хранится
карта взаимоотношений с людьми, опора на эти переживания приносит умиротворение».
К сожалению, большинство людей не имеют такой карты.
Почти с момента зарождения психотерапии стало ясно, что люди страдают из-за «ран
нелюбви» вследствие фрустрации детских потребностей в эмоциональном тепле и любви.
Эта «недолюбленность» передается, как инфекция, от поколения к поколению.
Потребность в любви достигла масштабов эпидемии. Если понимать Любовь не как
преходящее чувство, а как состояние осознанности, раскрытия своей внутренней
Природы, то путь к Любви неотделим от пути самопознания. 
        'Каждый ребенок нуждается в том, чтоб его психическую реальность признавали и\n' +
                'отражали. Это требует определенной практики\n' +
            'Учитывая, что роль родительского присутствия и эмоционального контакта всё больше\n' +
            'подчёркивается в исследованиях развития мозга и личности, родителям необходимо\n' +
            'самим усваивать все нужные навыки для формирования здоровых отношений с\n' +
            'ребенком.'
            `
    },
    {
        id: "psy-5",
        title: '«Я не знаю кто я »',
        shortText: ' проблема поиска своей идентичности',
        fullText: 'Изначально наша природа это открытость. Если ребенок растет в среде,где эта\n' +
            'открытость не поддерживается,то он ищет формы приспособления к родительским\n' +
            'ожиданиям и замыкается . Приспосабливаясь к семье и обществу, мы теряем себя и\n' +
            'конструируем свое ложное Я. Это приводит к тому, что ребенок как бы отсоединяется от\n' +
            'себя, не понимая своих истинных чувств и потребностей. Впоследствии это ведет к\n' +
            'проблеме пустоты, душевного опустошения, развития депрессий.\n' +
            'В психотерапевтической практике можно постепенно восстанавливать связь с собой, приближаясь к пониманию своих глубинных чувств и потребностей, формирования своей большей целостности и связи с собой,что является непременным условием для своей устойчивости и наполненности.'
    },
    {
        id: "psy-6",
        title: '«Я не знаю чего я хочу»',
        shortText: ' проблема подавления своих потребностей',
        fullText: 'Одной из частых проблем, встречающихся в психотерапевтической практике, является\n' +
            'подавление своих потребностей, что может препятствовать получению позитивных\n' +
            'эмоций, ощущению удовлетворенности и влиять на снижение уровня жизненной\n' +
            'энергии.\n' +
            'Если задуматься то вся наша жизнь исходит из наших потребностей. От того насколько мы\n' +
            'способны осознавать свои глубинные потребности и реализовывать зависит наше\n' +
            'психологическое благополучие.\n' +
            'В гештальт-терапии незавершенный гештальт связан не только с нереализованной\n' +
            'потребностью. Это может быть не доведенная до логического финала эмоциональная или\n' +
            'поведенческая реакция в прошлом, которая создает психологическое напряжение и\n' +
            'отбирает энергетические ресурсы в настоящем. Такой процесс объясняется тем, что при\n' +
            'возникновении потребности или намерения к определенному действию выделяется\n' +
            'часть психической энергии и в целостном процессе импульс стремится к завершению.\n' +
            'Как только потребность удовлетворена, гештальт отступает на задний план, теряет свою\n' +
            'значимость. Такой ритм формирования и завершения гештальтов является естественным\n' +
            'ритмом жизнедеятельности организма. Если же потребность не удовлетворяется и\n' +
            'гештальт остается незавершенным, то большое количество энергии расходуется на\n' +
            'поддержание этой незаконченной ситуации, что приводит к истощению ресурсов\n' +
            'человека\n' +
            'Поскольку источник энергии лежит в положительных эмоциях, что связано с\n' +
            'удовлетворением своей потребности, то особое внимание следует уделять процессам\n' +
            'формирования и здоровым способам удовлетворения своих потребностей. Это дает\n' +
            'возможности для высвобождения подавленных энергетических ресурсов. И в этом случае\n' +
            'гештальт может быть завершен. Для этого нужно освоить нужные методы.'
    },
    {
        id: "psy-7",
        title: '«Я все время в мыслях»',
        shortText: ' проблема фиксации на мыслительной деятельности',
        fullText: 'Игнорирование своих чувств и фиксация на мыслительной деятельности ведут к тому, что\n' +
            'жизненная энергия полностью перемещается в голову, и при этом жизнь становится\n' +
            'виртуальной, поскольку лишена непосредственных ощущений, чувств и естественного\n' +
            'течения энергии. Таким образом, нарушается наше базовое эмоциональное здоровье.\n' +
            'Для восстановления целостности проживания своего внутреннего опыта необходима\n' +
            'интеграция мыслительной деятельности со сферой чувств и ощущений, на что и\n' +
            'направлены телесно-ориентированные методы работы, в основе которых используются\n' +
            'глубокие связи между ментально-психическими и физическими процессами.'
    },
    {
        id: "psy-8",
        title: '«Я живу на автопилоте»',
        shortText: 'проблема проблема стереотипного поведения',
        fullText: 'Кому это не знакомо? В неосознанном состоянии мы часто совершаем механические\n' +
            'действия, не осознавая их последствий.\n' +
            'Практика осознанности определяется как непрерывное наблюдение текущих\n' +
            'переживаний, развитие фокусировки на проживании опыта в настоящем моменте вместо\n' +
            'привычного способа следования за реактивным умом или мыслительной деятельностью,\n' +
            'направленной на прошлое или будущее. Это дает возможность переключать внимание с\n' +
            'мыслительной деятельности, например, с размышлений о том, что не имеет значения и\n' +
            'представляет достаточно энергозатратный процесс, на текущий опыт проживания чувств\n' +
            'и эмоций, что ведет к осознанному проживанию своего опыта и перенаправление\n' +
            'энергии в более продуктивную деятельность.'
    },
    {
        id: "psy-9",
        title: '«У меня много стрессов» ',
        shortText: 'проблема саморегуляции',
        fullText: 'В нашей интенсивной современной жизни сложно избежать стрессов. Каждый стресс\n' +
            'продуцирует состояние напряженности в теле. Такие хронические мышечные\n' +
            'напряжения уменьшают индивидуальную энергию и ограничивают естественную\n' +
            'подвижность. Каждый зажатый мускул зажат некоторым движением. Определенные\n' +
            'навыки позволяют войти в контакт с этим мышечным напряжением и освободить его.\n' +
            'Любой стресс сопряжен с подавленными эмоциями, например, гнева или раздражения.\n' +
            'Таким образом, при работе с эмоциональными зажимами в гештальт-терапии создаются\n' +
            'условия, позволяющие клиенту сначала осознать свои чувства, прожить их на уровне\n' +
            'осознанности, разрядить и освободиться от незавершенных ситуаций, которые\n' +
            'порождают стереотипное невротическое поведение и отбирают энергию.'
    },
    {
        id: "psy-10",
        title: '«Я все время в напряжении»',
        shortText: 'проблема подавления своих эмоций',
        fullText: 'Подавление эмоций связано не только с мышечными зажимами, но и с неосознанной\n' +
            'задержкой дыхания. Поэтому очень важным компонентом является дыхание, которое\n' +
            'определяется как практика интеграции личности, дающая человеку доступ к ресурсам его\n' +
            'сознания и освобождающая его психику от груза накопленных стрессов. Именно дыхание\n' +
            'является связующим звеном между физическим и эмоциональным телом и стимулирует\n' +
            'телесные ощущения, эмоции и может вызвать энергетический выброс.\n' +
            'В результате дыхательных практик снижается уровень болезненных состояний и\n' +
            'психической напряженности, повышается уровень чувствительности, улучшается баланс\n' +
            'личностных психологических качеств, происходит раскрытие внутренних энергетических\n' +
            'ресурсов человека.'
    },
    {
        id: "psy-11",
        title: '«Мне одиноко»',
        shortText: ' проблема изолированности',
        fullText: 'Одной из частых проблем в психотерапевтической практике является проблема\n' +
            'изолированности человека по различным причинам (недоверие, неспособность к\n' +
            'самораскрытию и др.), что может вести к коммуникативным трудностям и самоизоляции.\n' +
            'Как утверждает психиатр Эми Бэнкс, человеческие отношения это естественный и\n' +
            'необходимый источник позитивных эмоций и энергии. Это обусловлено устройством\n' +
            'нашего мозга. Согласно ее разработкам это отражается на нейронных путях, в итоге чего\n' +
            'наступает каскад неврологических реакций, что может повлечь за собой хроническую\n' +
            'раздражительность, гнев, депрессию и психосоматические заболевания. Бэнкс отмечает,\n' +
            'что человеческий мозг невероятно «теплолюбив» и ему нужны близость и принятие.\n' +
            'Контакты с приятными людьми заряжают нас энергией, что обеспечивается дофаминовой\n' +
            'системой вознаграждения.\n' +
            'Различные навыки подлинного контакта позволяют развить навыки самораскрытия, что\n' +
            'естественным образом ведет к расширению межличностных связей и ощущению\n' +
            'единства с окружающим миром.'
    },
    {
        id: "psy-12",
        title: '«Все бессмысленно, я странно себя чувствую»',
        shortText: 'проблема духовного кризиса',
        fullText: 'Важно отметить, что часто нарушение жизненного баланса может быть связано с\n' +
            'личностным или духовным кризисом, что сопряжено с нашим внутренним ростом и\n' +
            'развитием. Кроме того, существуют возрастные кризисы, во время которых многие люди\n' +
            'испытывают процессы глубинных внутренних перемен. Такие переломные моменты\n' +
            'связаны с потерей прежних ценностей и установок. Обычно это сопровождается\n' +
            'состоянием подавленности, хаотичности, повышенной тревожности и беспомощности\n' +
            'человека. Такое состояние также может сопровождаться признаками эмоционального\n' +
            'выгорания и влиять на качество и продуктивность его деятельности, нарушая жизненный\n' +
            'баланс человека. Опыт проживания глубоких личностных кризисов требует\n' +
            'профессиональной психологической помощи и являет собой возможность личностной\n' +
            'трансформации, что может вести к большей целостности, раскрытию внутренних сил и\n' +
            'энергий.'
    },
    {
        id: "psy-13",
        title: '«Я все время устаю»',
        shortText: 'проблема нарушенного жизненного баланса',
        fullText: 'Нарушенная циркуляция энергии и негармоничное распределение энергетических\n' +
            'потоков в своей жизнедеятельности являются коренной причиной всех психологических\n' +
            'и физических нарушений. К основным причинам траты энергии относят нездоровое\n' +
            'питание, неосознанные мышечные зажимы, неправильное поверхностное дыхание,\n' +
            'негативные эмоции, противоречивые желания, чрезмерную мыслительную\n' +
            'деятельность; к способам повышения энергии — здоровое питание, физическую\n' +
            'активность для снятия мышечных зажимов, практику глубокого дыхания, проработку\n' +
            'эмоциональных зажимов, преобразование негативного мышления, интеграцию\n' +
            'внутренних противоречий, развитие эмоциональной открытости, практику осознанности.'
    },
    {
        id: "psy-14",
        title: '«Я не знаю для чего я живу»',
        shortText: 'проблема поиска смысла жизни',
        fullText: 'С такими экзистенциальными запросами некоторые люди обращаются и находят свои\n' +
            'ответы в психотерапии. С точки зрения логотерапии феномен пустоты можно объяснить\n' +
            'отсутствием истинного, экзистенциального смысла.\n' +
            'А.Лэнгле приводит следующее: «Как ощущается жизнь, в которой человек нашел\n' +
            'истинный смысл? Как вдохновляющая, полная переживаний, как жизнь, которой\n' +
            'отдаешься с чувством внутреннего согласия, в которой я как активный участник,\n' +
            'сделавший свободный выбор и готовый за него ответить. Как переживается жизнь, в\n' +
            'которой найденный смысл оказался ложным? Она истощает, отнимает все силы, ты отдан\n' +
            'ей на растерзание, несвободен, как будто кто-то управляет тобой извне, а ты лишь\n' +
            'формально функционируешь; такая жизнь бедна глубокими переживаниями, зато в ней\n' +
            'много обязательств, и это давит на тебя».\n' +
            'Когда человек мотивирован не самим делом, которым он занимается, а ложными,\n' +
            'навязанными целями (карьерные устремления, власть, признание, социальное принятие,\n' +
            'исполнение долженствования вместо своих подлинных желаний), то он ощущает\n' +
            'глубокую неудовлетворенность своей жизнью.\n' +
            'Жизнь из чувства долга может быть похожа на избегание жизни. Она основана на\n' +
            'отчуждении от жизни и от самого себя» . Жить такой жизнью означает делать то, что, как\n' +
            'ты думаешь, люди ждут от тебя. Но в такой жизни человек редко принимает участие\n' +
            'целиком, и, таким образом, постепенно теряет мотивацию продолжать то, что все больше\n' +
            'становится похожим на выполнение какой-то обязанности.\n' +
            'Вместо того, чтобы наполнять свою жизнь долженствованиями или иметь\n' +
            'нереалистичные притязания, можно научиться жить, обращая внимание как на свои\n' +
            'возможности, так и на ограничения, порожденные собственным выбором и\n' +
            'обязательствами.\n' +
            'Поиск смысла это очень личный процесс, в процессе которого можно выделить те\n' +
            'задачи и аспекты, которых человек не осознает. В ходе такого критичного\n' +
            'переосмысления многое, что воспринималось невозможным, оказывается навязанным и\n' +
            'для человека раскрывается осознание права на свой собственный выбор. С этой вновь\n' +
            'обретенной свободой человек начинает лучше действовать в своих конкретных\n' +
            'жизненных обстоятельствах.'
    },
    {
        id: "psy-15",
        title: '«Я не могу без него жить»',
        shortText: 'проблема эмоциональной зависимости',
        fullText: 'Эмоциональная любовная зависимость описывается в искусстве как высшее проявление\n' +
            'любви, но на практике жизни, к сожалению, это не всегда так. Вместо « я хочу быть с\n' +
            'тобой» формируется «я умру без тебя», когда есть чрезмерная фиксация на отношениях\n' +
            'при игнорировании других сфер жизни, патологическая поглощенность другим\n' +
            'человеком вплоть до утраты ценностных оснований личностной идентичности.\n' +
            'Большей частью психология обьясняет это недостатком любви в детско-родительских\n' +
            'отношениях, когда человек таким образом пытается реализовать неутоленную\n' +
            'потребность. Однако, есть разные причины и следствия, приводящие к такому опыту\n' +
            'отношений. Однако, есть другие различные психологические факторы, которые\n' +
            'формируют почву для развития аддиктивных расстройств и зависимых отношений.\n' +
            'Поверхностный взгляд и тенденция видеть в аддиктах искателей удовольствия и людей со\n' +
            'слабой волей мешает нам понимать всю сложность и палитру проблематики\n' +
            'зависимости. Во многих случаях эти указанные поверхностные факторы связаны с более\n' +
            'глубокими проблемами человеческих взаимоотношений.\n' +
            'Психотерапия играет важнейшую роль в освоении навыков саморегуляции. Фокусом\n' +
            ',например, гештальт- терапии как раз является освоение саморегуляции , развитие\n' +
            'способности заботы о себе, формирование личностных границ и установление здоровых\n' +
            'отношений с агрессией.\n' +
            'По словам Экхарта Толле: Отношения могут являть собой сущий ад либо великую\n' +
            'духовную практику.'
    },
    {
        id: "psy-16",
        title: '«Все время заедаю»',
        shortText: 'проблема пищевой зависимости',
        fullText: 'Нейробиологи разьясняют формирование зависимости через поиск удовольствия и\n' +
            'привязанность к ней. В самом деле, что является самым глубинным двигателем для\n' +
            'нашего поведения? это удовольствие, стремление к положительным эмоциям. И это\n' +
            'обусловлено нейробиологией.\n' +
            'В мозге были обнаружены «центры удовольствия» в лимбической системе, участвующей в\n' +
            'обработке эмоций. Все значимое для нас - вкусная еда, новая информация, сексуальные\n' +
            'контакты и другие удовольствия это все стимулы, запускающие центры положительных\n' +
            'эмоций. Нейробиологи считают наркотики, так называемые «препараты эйфории»,\n' +
            'связанные с нейромедиаторами- дофамином, амфетамин,кокаин, нороадреналином,\n' +
            'эндорфинами, которые влияют на центры положительных эмоций, наиболее опасными,\n' +
            'приводящими сначала к психологической, а через некоторое время и физиологической\n' +
            'зависимости. Так как любая привычка меняет работу мозга, то такой опыт может\n' +
            'перекосить нервную систему: дофаминовые синапсы организуются вокруг одного\n' +
            'источника удовольствия. Так как дофамин является нашим главным вознаграждением, то\n' +
            'вся система удовольствия начинает проявляться через определенный канал аддиктивной\n' +
            'реализации. Поэтому все усилия направляются на этот источник удовольствия, игнорируя\n' +
            'все другие жизненные сферы.\n' +
            'С точки зрения нейробиологии зависимость определяется определенными структурами\n' +
            'мозга, отвечающие за краткосрочные поведенческие акты и контроль, связанный с\n' +
            'удержанием. В этом случае человек не испытывает беспокойства по поводу своей\n' +
            'зависимости и не способен предвидеть ее долгосрочные последствия. Если не\n' +
            'сформированы навыки саморегуляции, то формируется способ проживать чувства через\n' +
            'аддиктивную реализацию.\n' +
            'Психотерапия играет важнейшую роль в освоении навыков саморегуляции.\n' +
            'В гештальт-терапии применяется очень бережный и деликатный подход к человеку,\n' +
            'чтобы провести его через последовательные этапы опыта, прежде чем он будет готов\n' +
            'воспринять новое представление о себе и менять свое поведение в этом направлении.'
    },
    {
        id: "psy-17",
        title: '«У моего ребенка аутизм»',
        shortText: 'проблема самоподдержки родителей особенных детей',
        fullText: 'Особая категория людей, с кем я работаю это родители детей с особенностями в\n' +
            'развитии.\n' +
            'Родители детей с особенностями развития часто испытывают колоссальное\n' +
            'эмоциональное выгорание, сталкиваясь с тяжелыми психическими нагрузками.\n' +
            'Это сопряжено с различными трудностями, которые они преодолевают с момента\n' +
            'постановки диагноза ребенка. Родители проживают сложный психологический процесс\n' +
            'адаптации, характерный для любой кризисной ситуации и описываемый в\n' +
            'последовательности фаз: отрицание, когда родитель не способен принять диагноз своего\n' +
            'ребенка, затем этапы растерянности и беспомощности, и эмоциональные переживания в\n' +
            'виде гнева, обиды, отчаяния.\n' +
            'Речь и мышление ребенка осваиваются именно в процессе отношений благодаря\n' +
            'взаимному обмену эмоциональными сигналами и жестами. Таким образом, для развития\n' +
            'психики очень существенно ощущение эмоциональной связи матери и ребенка. Эмоции\n' +
            'направляют развитие на всех этапах и представляют собой те силы, которые позволяют\n' +
            'учиться и осваивать навыки развития/\n' +
            'Для детей с аутизмом особенно необходима ясность, четкость и выразительность\n' +
            'эмоциональных реакций и проявлений. А это представляет трудность для родителей,\n' +
            'которые находятся в крайне угнетенном состоянии и не способны на эмоциональную\n' +
            'экспрессию, и может усугубить сложности коммуникаций с ребенком.Такое\n' +
            'самоощущение мамы вполне понятно: ребенок не подкрепляет ее материнского\n' +
            'поведения, не улыбается, не смотрит ей в глаза, не любит бывать на руках, не несет ей\n' +
            'эмоционального отклика .\n' +
            'Чтобы стимулировать осознание и выражение чувств, существует большое разнообразие\n' +
            'специфических гештальт-методов для развития экспрессии.\n' +
            'В формировании родительской позиции принятия ребенка крайне важна\n' +
            'психотерапевтическая помощь, поскольку это сопряжено с сильными чувствами (гнев,\n' +
            'обида, отчаяние), выражающимися в вопросе: «Почему именно мой ребенок?!» Такие\n' +
            'глубинные проблемы не могут быть решены быстро и просто, их решение требует\n' +
            'существенных жизненных изменений. А это становится возможным благодаря поиску\n' +
            'человеком более эффективного способа существования, пересмотру им своих\n' +
            'взаимоотношений с Миром и ответам на экзистенциальные вопросы в рамках\n' +
            'психотерапевтических отношений.\n' +
            'Это требует продолжительного времени. До тех пор, пока мама не построит новые,\n' +
            'реалистичные, мечты о ребенке, она будет чувствовать беспокойство и тревогу.\n' +
            'Проделанная внутренняя работа по принятию дает возможность видеть своего ребенка\n' +
            'более реалистично, позволяет получать удовольствие от текущей жизни и встречать\n' +
            'жизненные трудности с надеждой.\n' +
            'Отказ от своего Я. Родители детей с особенностями развития часто полагают, что они\n' +
            'больше не заслуживают полноценного отдыха и досуга, удовлетворения своих\n' +
            'потребностей, и начинают жестко ограничивать себя во всех сферах жизни, посвящая\n' +
            'жизнь только своему ребенку. Это приводит к большой энергозатратности и развитию\n' +
            'депрессивных состояний. В корне данной проблемы лежат иррациональные установки,\n' +
            'приводящие к избыточным чувствам вины и стыда. Очень важно для родителей, в\n' +
            'особенности, родителей «особенных» детей, осваивать навыки самоподдержки и заботы\n' +
            'о себе для того, чтобы поддерживать себя в ресурсном состоянии. Кроме внутренних\n' +
            'опор, важно использовать внешние источники поддержки, здоровый образ жизни, режим\n' +
            'дня, питания, физических упражнений, практики релаксационной медитации для снятия\n' +
            'мышечных зажимов, частое пребывание в контакте с природой и на свежем воздухе. Как\n' +
            'показывают исследования в этой области, чем больше родители заботятся о собственном\n' +
            'здоровье и благополучии, тем более улучшается качество жизни всей семьи и результаты\n' +
            'реабилитации ребёнка. «Счастливая мама — счастливый ребенок»!'
    },
    {
        id: "psy-18",
        title: '«Я хочу развестись»',
        shortText: 'проблема парных отношений',
        fullText: 'Сложности в отношениях - один из самых распространенных запросов в психотерапии.\n' +
            'Парная терапия это не способ укреплять и не способ разрушать пару, а возможность\n' +
            'сделать какие то аспекты своей жизни, свои поведенческие паттерны более\n' +
            'осознаваемыми. Это хороший способ сделать многие аспекты жизни пары ясными и\n' +
            'доступными для наблюдения, что может помочь паре самой принять осознанное\n' +
            'решение о том, как ей существовать.\n' +
            'Модели семейных отношений усваивается человеком в раннем детстве и часто\n' +
            'отыгрывается бессознательно. Причины нарушений поведения могут лежать в\n' +
            'укоренившемся опыте прошлого, который не соответствует актуальной ситуации. Когда\n' +
            'такой способ поведения становится привычным и неосознанным, он повторяется в\n' +
            'настоящем и препятствует возникновению нового, более конструктивного поведения.\n' +
            'Особенность семейной терапии заключается в исследовании того, как пара обходится с\n' +
            'теми различиями, которые могут быть источником конфликтов. Исследуется не только\n' +
            'индивидуальное поле, но и общее, их совместность.\n' +
            'Карл Витакер писал: «На самом деле человек очень долго должен учиться тому, как стать\n' +
            'частью «Мы», не разрушая самого себя. Сначала ты учишься любить себя, потом -\n' +
            'похожего на тебя человека, и лишь потом появляется смелость любить непохожего, и\n' +
            'тогда отношения становятся «...настоящим процессом создания совместности, докторской\n' +
            'степенью в области человеческих взаимоотношений, предполагающих все более полную\n' +
            'обращенность к другому с тем, чтобы все полнее выражать самого себя»'
    },
    {
        id: "psy-19",
        title: '«Как мне быть с другими  и оставаться собой?»',
        shortText: 'проблема слияния',
        fullText: 'Базовая человеческая дилемма состоит в том, что мы хотим быть связанны\n' +
            'ми с другими и хотим оставаться собой. Такая дилемма определяет проблему сепарации/\n' +
            'слияния. Как оставаться с другим и как оставаться собой? Мне важно иметь близкий\n' +
            'контакт, но важно и сохранять себя, не растворяться.\n' +
            'Мы пытаемся строить отношения, не создавая контакта. Из неспособности чувствовать\n' +
            'себя тем, кем мы являемся, это становится невозможным.\n' +
            'О том как учиться чувствовать себя, быть с другимим,не теряя фокуса на себе вы узнаете в\n' +
            'процессе терапии.'
    },
    {
        id: "psy-20",
        title: '«Я он или она»',
        shortText: 'проблема сексуальной самоидентификации',
        fullText: 'В современной культуре поощряется принадлежность к определенному полу.\n' +
            'Исторически биологический пол определяется половыми признаками. На самом деле это\n' +
            'гораздо более многомерный процесс. Если у животных можно определить пол по\n' +
            'половым признакам,то с человеком сложнее, где следует учитывать структуру хромосом\n' +
            'или гормональное строение.\n' +
            'Нейробиологи говорят, чем выше филогенетический уровень вида,тем сложнее\n' +
            'детерминация половой принадлежности и многограннее ее связь с другими аспектами\n' +
            'развития. Более сложный онтогенез увеличивают число вариаций развития в психике,\n' +
            'выходящих за рамки дихотомии мужское-женское.\n' +
            'Многие, так называемые небинарные люди, имеют психологиеские сложности не только\n' +
            'из за давления общества,но и формирования своей идентичности.\n' +
            'Задачей психотерапии является не коррекция его гендерной идентичности или\n' +
            'сексуальной ориентации, а поиск и расширение выражения его сексуальности и форм\n' +
            'творческой адаптации в окружающей среде.'
    },
    {
        id: "psy-21",
        title: '«Мне скучно жить»',
        shortText: 'проблема избегания контакта с собой и жизнью',
        fullText: `
        Скука в жизни является частым спутником тех, кто делают все, чтобы 
        не погрузиться в переживания полноты жизни. 
 В гештальт-терапии  человек получает возможность лучше узнать  
 себя , свои переживания, смысловые ценности , жизненные потребности, 
 что является необходимым фундаментом для каждого человека, некой опорой внутри себя, а для этого человек учится 
 встрече со своими чувствами и контакту с собой и другими в актуальном переживании и настоящем моменте.
        `}
]